import {createPortal} from 'react-dom'
import {useEffect} from 'react'
import {AiOutlineCloseCircle} from "react-icons/ai";

export default function Modal({open, onClose, children}) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function escHandler({key}) {
    if (key === 'Escape') {
      onClose()
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('keydown', escHandler);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('keydown', escHandler);
      }
    };
  }, [escHandler]);


  if (typeof document !== 'undefined') {

    return createPortal((
        <div className={`fixed inset-0 ${open ? '' : 'pointer-events-none'}`}>
          {/* backdrop */}
          <div
              className={`fixed inset-0 bg-white dark:bg-black max-w-[100%] ${open ? 'opacity-90' : 'pointer-events-none opacity-0'} transition-opacity duration-300 ease-in-out`}
              onClick={onClose}
          />

          {/* content */}
          <div className={`fixed right-0 pt-6 pb-10 max-w-[100%] top-[50%] left-[50%] rounded-2xl transform -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-nfr-color-800 shadow-lg w-[80%] ${open ? 'opacity-100' : 'pointer-events-none opacity-0'} transition-opacity duration-300 ease-in-out`}>
            <button
                className='fixed -top-2 -right-2 bg-white dark:bg-gray-800 rounded-full'
                onClick={onClose}
            ><AiOutlineCloseCircle size={30} color={'red'}/></button>
            <div className='overflow-auto max-h-[70vh] p-4 pb-20'>
              {children}
            </div>
          </div>
        </div>
    ), document.body)
  } else {
    return null
  }
}
